module.exports = __webpack_public_path__ + "img/phone.ae0f4e1a.png";